module.exports = __webpack_public_path__ + "static/pods-chart-0a29179c84e394944a570ffb1108a230.svg";